<template>
  <div class="media-input">
    <input type="file" class="form-control-file" multiple accept="image/jpeg" @change="onFileSelected" id="mediaInput" />
    <div class="progress" style="height: 4px;">
      <div class="progress-bar" id="progressBar" role="progressbar" style="width: 0%;" aria-valuemin="0" aria-valuemax="100"></div>
    </div>
    <!-- PREVIEW IMAGES -->
    <div v-for="media in mediaObject" class="preview-image-container">
      <div @click="deleteMedia(media)" class="preview-image-delete clickable">
        <i class="far fa-times"></i>
      </div><!-- /.preview-image-delete -->
      <img :src="media.small" width="100px">
    </div><!-- /.preview-image-container -->
    <!-- MEDIA PROCESSING WARNINGS -->
    <div class="alert alert-warning" role="alert" v-if="processingMedia">We are processing media... please hold tight!</div>
    <div class="alert alert-success" role="alert" v-if="mediaReady">All media ready for launch, captain!</div>
  </div><!-- /.media-input -->
</template>

<script>
  // Import Firebase and the vuex store
  import { mapState } from 'vuex'
  import firebase from 'firebase'
  // Establish the mediaPayload
  let mediaPayload = []
  export default {
    data() {
      return {
        // Use this as a check to make sure that all media has been processed before allowing form to be submitted
        processingMedia: false,
        mediaReady: false
      }
    },
    // Take the mediaObject prop
    props: ['mediaObject'],
    // Make sure the mediaPayload is empty on load
    created: function () {
      mediaPayload = []
      if (this.mediaObject.length > 0) {
        mediaPayload = this.mediaObject
      }
    },
    // Get the currentUser's data
    computed: {
      ...mapState(['currentUser'])
    },
    methods: {
      // What to do when files are selected
      onFileSelected(e) {
        /// Give us acess to this from within deeper functions
        let self = this
        // Loop through the files in the widget
        for (var i = 0; i < e.target.files.length; i++) {
          // Yes, we are processing media
          this.processingMedia = true
          // Create unique media ID
          function guid() {
            return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()
          }
          function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1)
          }
          let mediaId = guid()
          // Get the image item
          let file = e.target.files[i]
          // Get current User ID
          let userId = this.currentUser.uid
          // Cunstruct the path and storage reference for Firebase
          let mediaPath = 'media/' + this.currentUser.uid + '/' + mediaId + '.jpg'
          // Set the Firebase storage reference for this media item
          let storageRef = firebase.storage().ref(mediaPath)
          // Setup metadata for this media item. authorID is used by cloud function to know where to place edited media... in the user's media folder
          let metadata = {
            customMetadata: {
              'authorId': this.currentUser.uid
            }
          };
          // Upload the file to Firebase with task variable
          let task = storageRef.put(file, metadata)
          // Listen for state changes as media item is being uploaded
          task.on('state_changed', function progress(snapshot) {
            // Set percentage of the progress bat
            // todo - Make this progress bar smarter to take account of all media items being uploaded at the same time.
            let percentage = (snapshot.bytesTransferred / snapshot.totalBytes) * 100 + '%'
            document.getElementById('progressBar').style.width = percentage
          },
          function error(err) {
            // Catch errors from the upload of this media item
            console.log('errors: ' + err)
          },
          function complete() {
            // Establish variables for the Firebase paths we know will exist once
            let resizedSmallMediaPath = 'media/' + userId + '/resized-small-' + mediaId + '.jpg'
            let resizedMediumMediaPath = 'media/' + userId + '/resized-medium-' + mediaId + '.jpg'
            let resizedLargeMediaPath = 'media/' + userId + '/resized-large-' + mediaId + '.jpg'
            let fullMediaPath = 'media/' + userId + '/' + mediaId + '.jpg'
            // Establish variables for the storage references of these new images we know are being processed
            let resizedSmallStorageRef = firebase.storage().ref(resizedSmallMediaPath)
            let resizedMediumStorageRef = firebase.storage().ref(resizedMediumMediaPath)
            let resizedLargeStorageRef = firebase.storage().ref(resizedLargeMediaPath)
            let fullStorageRef = firebase.storage().ref(fullMediaPath)
            // Establish the media object that we will build with this media item for the payload
            let mediaObject = {type:"image"}
            // Checks to see if the various sizes have successfully processed on Firebase
            let haveSmall = false;
            let haveMedium = false;
            let haveLarge = false;
            // We already have the Firebase path of the original media. Place it in the media object
            mediaObject.path = fullMediaPath;
            // Get the actual URL of the fullsized image
            fullStorageRef.getDownloadURL().then(function(fullMediaUrl) {
              // Assign this URL to the media object
              mediaObject.full = fullMediaUrl
            }).catch(function(error) {console.log(error)})
            // Function for checking that the small thumbnail exists and getting its actual URL. If no image yet, wait 5 seconds and run this again. Repeat until a success.
            function getThumbSmall() {
              resizedSmallStorageRef.getDownloadURL().then(function(thumbSmallMediaUrl) {
                self.processingMedia = true
                mediaObject.small = thumbSmallMediaUrl
                haveSmall = true
                completeMediaObject()
              }).catch(function(error) {
                console.log(error)
                if (error.name !== 'FirebaseError') {
                  return;
                } else {
                  setTimeout(function () {
                    getThumbSmall()
                  }, 5000)
                }
              })
            }
            // Function for checking that the medium thumbnail exists and getting its actual URL. If no image yet, wait 5 seconds and run this again. Repeat until a success.
            function getThumbMedium() {
              resizedMediumStorageRef.getDownloadURL().then(function(thumbMediumMediaUrl) {
                self.processingMedia = true
                mediaObject.medium = thumbMediumMediaUrl
                haveMedium = true
                completeMediaObject()
              }).catch(function(error) {
                console.log(error)
                if (error.name !== 'FirebaseError') {
                  return;
                } else {
                  setTimeout(function () {
                    getThumbMedium()
                  }, 5000)
                }
              })
            }
            // Function for checking that the large thumbnail exists and getting its actual URL. If no image yet, wait 5 seconds and run this again. Repeat until a success.
            function getThumbLarge() {
              resizedLargeStorageRef.getDownloadURL().then(function(thumbLargeMediaUrl) {
                self.processingMedia = true
                mediaObject.large = thumbLargeMediaUrl
                haveLarge = true
                completeMediaObject()
              }).catch(function(error) {
                console.log(error)
                if (error.name !== 'FirebaseError') {
                  return;
                } else {
                  setTimeout(function () {
                    getThumbLarge()
                  }, 5000)
                }
              })
            }
            // Run these functions to start getting processed media
            getThumbSmall()
            getThumbMedium()
            getThumbLarge()
            // Check if all three processed media have fully been processed and captured
            function completeMediaObject() {
              if (haveSmall == true && haveMedium == true && haveLarge == true) {
                // Push our constructed media object over to the media payload
                mediaPayload.push(mediaObject)
                document.getElementById('progressBar').style.width = 0
                // Nope... we are no longer processing and the media is ready for launch!
                self.processingMedia = false
                self.mediaReady = true
                self.$emit('processingMedia', self.processingMedia)
              } else { return }
            }
          })
        } // end loop for media item
        // Send the media payload over to the media delivery function
        this.mediaDelivery(mediaPayload)
      },
      // Take the media payload and emit it up to the submission form
      mediaDelivery(mediaPayload) {
        this.$emit('mediaDelivery', mediaPayload)
        // Emit if we are processing media. This will be used by the form to prevent submission while processing
        this.$emit('processingMedia', this.processingMedia)
      },
      deleteMedia(media) {
        // Create new media object variable
        let newMediaObject = []
        // Loop through the media object array and look for this object.
        for (let i = 0; i < this.mediaObject.length; i++) {
          // If not this piece of media, add to the new media object
          if (this.mediaObject[i].path != media.path) {
            newMediaObject.push(this.mediaObject[i])
          } else {
            // Otherwise skip the item in question and remove it from firebase
          }
        } // end Loop
        // Send the updated data back to the media object
        this.mediaObject = newMediaObject
        // Deliver the new media object array to the form
        this.$emit('mediaDelivery', newMediaObject)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/MediaInput.vue